import api from "../../services/api";
import { types } from "../types/types";
import Constants from "../../services/constants";
import { hideLoaderAction, showLoaderAction } from "./loaderAction";
import { showToast } from "./toastAction";

const getUsers = (setLoading, search = "", status = "ALL") => async (dispatch) => {
    dispatch(showLoaderAction());
    if (setLoading) {
        setLoading(true);
    }
    const query = new URLSearchParams({ page: "1", limit: "50" });
    if (search.trim()) {
        query.set("search", search.trim());
    }
    if (status && status !== "ALL") {
        query.set("status", status);
    }
    const res = await api("get", `${Constants.END_POINT.USER}?${query.toString()}`);
    if (res.success) {
        if (res.data) {
            dispatch({
                type: types.CHANGE_USER,
                payload: res.data,
            });
        }
    }
    if (setLoading) {
        setLoading(false);
    }
    dispatch(hideLoaderAction());
};
const getUser = (id, returnData) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("get", Constants.END_POINT.USER + id);
    if (res.success) {
        if (res.data) {
            if (returnData) {
                returnData(res.data);
            }
        }
    }
    dispatch(hideLoaderAction());
};
// Irreversible: removes the user, unlinks their vehicles and kills the linked QR codes.
const userDeleteAction = (id, onDone) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("delete", Constants.END_POINT.USER + id);
    if (res.success) {
        dispatch(showToast({ severity: "success", summary: res.message }));
        if (onDone) onDone();
        else dispatch(getUsers());
    } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
    }
    dispatch(hideLoaderAction());
};
// Reversible: hides the account and its data but unlinks nothing, so a restore puts
// the user back exactly as they were.
const softDeleteUser = (id, onDone) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("delete", Constants.END_POINT.USER_SOFT_DELETE + id);
    if (res.success) {
        dispatch(showToast({ severity: "success", summary: res.message }));
        if (onDone) onDone();
    } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
    }
    dispatch(hideLoaderAction());
};

const restoreUser = (id, onDone) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("put", Constants.END_POINT.USER_RESTORE + id, {});
    if (res.success) {
        dispatch(showToast({ severity: "success", summary: res.message }));
        if (onDone) onDone();
    } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
    }
    dispatch(hideLoaderAction());
};

const disableUser = (id, isBlocked) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("delete", Constants.END_POINT.USER_DISABLE + id, { isBlocked });
    if (res.success) {
    } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
    }
    dispatch(hideLoaderAction());
};
export { getUsers, getUser, userDeleteAction, softDeleteUser, restoreUser, disableUser };
